/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms, TableView } from "@src/app/model/sys/nav-item";
import { MONTHLY_TYPE, WEEKLY_TYPE } from "@src/app/modules/crm/request-analysis/request-analysis.component";
import { currentPeriod, priorPeriod } from "@src/app/modules/crm/request-analysis/analysis-period";
import { RequestAnalysisByUserComponent } from "@src/app/modules/crm/request-analysis-by-user/request-analysis-by-user.component";
import { NavRoute } from "@src/app/shared/NavRoute";

/* breakdownId is the user on the full report and the OMC once drilled down to one user */
const RABUCharts = [
    { type: 'bar', picklist: 'breakdownId', number: 'requestsClosed', showOnly: 0, sortBy: 'value' } as ChartParms,
    { type: 'bar', picklist: 'breakdownId', number: 'actionsClosed', showOnly: 0, sortBy: 'value' } as ChartParms,
    { type: 'bar', picklist: 'breakdownId', number: 'timeSpent', showOnly: 0, sortBy: 'value' } as ChartParms,
    { type: 'bar', picklist: 'breakdownId', number: 'backlogRequests', showOnly: 0, sortBy: 'value' } as ChartParms,
];

/* Built each time a view is chosen, so "previous" and "current" are always relative to today */
function RABUViews(): TableView[] {
    const thisWeek = currentPeriod('week');
    const thisMonth = currentPeriod('month');
    return [
        {
            id: 'previousWeek',
            name: $localize`Previous Full Week`,
            helpText: 'Work by user for the last full week, compared with the week before it',
            filterFields: { periodType: WEEKLY_TYPE.id, period: priorPeriod(thisWeek) },
        },
        {
            id: 'currentWeek',
            name: $localize`Current Week To Date`,
            helpText: 'Work by user so far this week, compared with the whole of last week',
            filterFields: { periodType: WEEKLY_TYPE.id, period: thisWeek },
        },
        {
            id: 'previousMonth',
            name: $localize`Previous Full Month`,
            helpText: 'Work by user for the last full month, compared with the month before it',
            filterFields: { periodType: MONTHLY_TYPE.id, period: priorPeriod(thisMonth) },
        },
        {
            id: 'currentMonth',
            name: $localize`Current Month To Date`,
            helpText: 'Work by user so far this month, compared with the whole of last month',
            filterFields: { periodType: MONTHLY_TYPE.id, period: thisMonth },
        },
    ];
}

export const RequestAnalysisByUserPageNavRoute = new NavRoute('crm/requestAnalysisByUser',
    () => RequestAnalysisByUserComponent, 'groups')
    .setCharts(RABUCharts).setViews(RABUViews);
